
(function(){
  function tagPills(root){
    if(!root) return;
    root.querySelectorAll('.text-block.custom').forEach(function(el){
      var t = (el.textContent || '').trim().toLowerCase();
      if(!t) return;

      if(t.indexOf('per la tua musica') !== -1){
        el.classList.add('lf-pill--music');
      } else if(t.indexOf('per i tuoi motori') !== -1 || t.indexOf('modularità') !== -1){
        el.classList.add('lf-pill--motori');
      } else if(t.indexOf('personalizzazione') !== -1 || t.indexOf('spazio') !== -1){
        el.classList.add('lf-pill--personal');
      } else if(t.indexOf('bellezza') !== -1 || t.indexOf('per il tuo orto') !== -1){
        el.classList.add('lf-pill--bellezza');
      }
    });
  }

  function run(){
    tagPills(document.querySelector('[id$="__marquee_7FLj6d"]'));
    tagPills(document.querySelector('[id$="__marquee_9et3Bd"]'));
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();